import { useEffect } from 'react';

import { PreviewPartMesh } from 'app/modules/wallforming/components/scenes/objects/placement-preview/PreviewPartMesh';

import type { PartPlacement } from 'api/models';
import type { ArticleMesh } from 'app/modules/wallforming/components/scenes/objects/articles/types/articleMesh';

interface PreviewPartProps {
    articleMeshes: ArticleMesh[];
    part: PartPlacement;
    useDefaultMaterial: boolean;
    onLoaded?: () => void;
}
export const PreviewPart = ({ articleMeshes, part, useDefaultMaterial, onLoaded }: PreviewPartProps) => {
    useEffect(() => {
        onLoaded?.();
    }, [onLoaded]);

    return <PreviewPartMesh articleMeshes={articleMeshes} part={part} useDefaultMaterial={useDefaultMaterial} />;
};
